import React, { useCallback, useEffect, useState } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { routeInfo, userCredentials } from 'recoilState/GlobalState';

import s from "styles/pages/Pages.module.scss"
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { Buttons, HeaderButton } from "components";
import { ACTIONS } from "consts/Actions";
import { Add, Cached, EditOutlined, DeleteOutlineRounded, VisibilityRounded } from '@mui/icons-material';
import { useService } from 'components/route/ServiceRoute';
import { hospitalesTitles as titles } from "consts/titulos-de-tablas";
import XGrid from 'components/UI/Grid/XGrid';
import { RNHHospitalGet } from 'services/services-mia/RNHHospitalGet';
import ViewModal from './Actions/ViewModal';

export default function HospitalesSalud() {
    const setRoute = useSetRecoilState(routeInfo);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [hopitales, setHospitales] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} })
    const [connectionRoles, setConnectionRoles] = useState([]);
    const [forceUpload, setForceUpload] = useState(false);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const service = useService()
    const credentials = useRecoilValue(userCredentials);

    const updateList = useCallback(() => { setForceUpload((value) => !value); }, [])

    const getHospitalesData = async (reset) => {
        setRowSelected({ status: false, row: {} })
        setPage(0)
        setHospitales([]);
        setIsLoading(true);
        const result = await RNHHospitalGet(credentials)
        const newRows = result[0]?.rnhHospitalId ? result.map((item) => {
            return {
                id: item.rnhHospitalId,
                name: item.rnhHospitalNombre,
                cod: item.rnhHospitalCod,
                nivelId: item.rnhNivelId,
                nivel: item.rnhNivelNombre,
                areaId: item.rnhAreaId,
                area: item.rnhAreaNombre,
                zonaId: item.rnhZonaId,
                zona: item.rnhZonaNombre,
                cabecera: item.rnhHospitalCabecera === "B" ? "Ambas" : item.rnhHospitalCabecera === "A" ? "De Area" : item.rnhHospitalCabecera === "Z" ? "De zona" : "Ninguno",
                localidad: item.localidadNombre,
            };
        }) : [];
        setHospitales(newRows);
        setIsLoading(false);
        return {
            rows: newRows,
            rowCount: newRows.length,
        };
    }
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    useEffect(() => {
        if (modalDetails.isOpen === false) {
            getHospitalesData()
        }
    }, [service, updateList, modalDetails.isOpen])

    useEffect(() => {
            setRoute({
                wordKey: `Hospitales - Programa Salud RN`
            })
        }, [service.servicioNombre, setRoute])

    return (
        <main className={s.main}>
            <Modal big={modalDetails.procede === ACTIONS.INSERT || modalDetails.procede === ACTIONS.UPDATE || modalDetails.procede === ACTIONS.HISTORY} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        user={rowSelected.row}
                        roles={connectionRoles}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <DeleteModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={updateList}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.VIEW && (
                    <ViewModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={updateList}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={s["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getHospitalesData() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Ver"}
                        handleClick={handleClick}
                        data={{
                            title: "Ver Hospital",
                            procede: ACTIONS.VIEW
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <VisibilityRounded/>
                    </HeaderButton>
                    <HeaderButton
                        text={"Crear"}
                        handleClick={handleClick}
                        data={{
                            title: "Crear Hospital",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Editar"}
                        handleClick={handleClick}
                        data={{
                            title: "Editar Hospital",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar Hospital",
                            procede: ACTIONS.DELETE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <DeleteOutlineRounded />
                    </HeaderButton>
                </Buttons>
            </div>

            <div className={s.container}>
                <XGrid
                    rows={hopitales}
                    titles={titles}
                    loading={isLoading}
                    updateList={getHospitalesData}
                    forceUpload={forceUpload}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                    page={page}
                    setPage={setPage}
                />
            </div>
        </main>
    )
}
